module.exports = __webpack_public_path__ + "static/media/img-benefit-applewatch-2.d319acc3.png";